'use client'

import { useEffect } from 'react'

import { IconAlertCircleYellow } from '@/shared/assets/icons'
import { trackDatadogError } from '@/shared/external/datadog'
import { COMMON_ERROR_DESCRIPTION, COMMON_ERROR_TITLE } from '@/shared/lib'
import { Result, withChunkErrorFallback } from '@/shared/ui'

interface IErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

const Error = ({ error, reset }: IErrorProps) => {
  useEffect(() => {
    trackDatadogError(error, { componentName: 'RegistrationByModelPage' })
  }, [error])

  const handleRetry = () => {
    reset()
  }

  return (
    <div className='flex max-w-[480px] mx-auto h-dvh justify-center items-center'>
      <Result
        icon={<IconAlertCircleYellow width='56' height='56' />}
        title={COMMON_ERROR_TITLE}
        description={COMMON_ERROR_DESCRIPTION}
        handleRetry={handleRetry}
      />
    </div>
  )
}

export default withChunkErrorFallback(Error, 'RegistrationByModelPage')
